module.exports = __webpack_public_path__ + "img/114.a2808790.png";